export default "__VITE_ASSET__CL03x_kw__"